var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3439 19.4999C35.3448 19.6603 35.314 19.8193 35.2534 19.9678C35.1927 20.1163 35.1034 20.2513 34.9904 20.3652L24.0217 31.334C23.7922 31.5635 23.4809 31.6924 23.1564 31.6924C22.8318 31.6924 22.5205 31.5635 22.291 31.334C22.0615 31.1045 21.9326 30.7932 21.9326 30.4686C21.9326 30.1441 22.0615 29.8328 22.291 29.6033L32.4067 19.4999L22.291 9.39646C22.1774 9.28282 22.0873 9.14792 22.0258 8.99945C21.9643 8.85098 21.9326 8.69185 21.9326 8.53115C21.9326 8.37044 21.9643 8.21131 22.0258 8.06284C22.0873 7.91437 22.1774 7.77947 22.291 7.66583C22.4047 7.5522 22.5396 7.46206 22.688 7.40056C22.8365 7.33906 22.9956 7.30741 23.1564 7.30741C23.3171 7.30741 23.4762 7.33906 23.6247 7.40056C23.7731 7.46206 23.908 7.5522 24.0217 7.66583L34.9904 18.6346C35.1034 18.7485 35.1927 18.8835 35.2534 19.032C35.314 19.1805 35.3448 19.3395 35.3439 19.4999Z",
    fill: "#0174EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3437 19.5C35.3437 19.8232 35.2153 20.1332 34.9868 20.3618C34.7582 20.5903 34.4482 20.7187 34.125 20.7187L4.875 20.7187C4.55177 20.7187 4.24177 20.5903 4.01321 20.3618C3.78465 20.1332 3.65625 19.8232 3.65625 19.5C3.65625 19.1768 3.78465 18.8668 4.01321 18.6382C4.24177 18.4097 4.55177 18.2812 4.875 18.2812L34.125 18.2812C34.4482 18.2812 34.7582 18.4097 34.9868 18.6382C35.2153 18.8668 35.3437 19.1768 35.3437 19.5Z",
    fill: "#0174EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c72da657934e2afa879afaf3f2f4008f.svg";
export { ForwardRef as ReactComponent };